export default __webpack_public_path__ + "assets/icons/homeBackground1.2be995b0.svg";